import { RootState } from 'store/index';
import createResourceListSelectors from 'store/ResourceListSelectors';
import { HighlightState, ResourceListSelectors } from 'typings/state';

const selectors: ResourceListSelectors = createResourceListSelectors(
    (state: RootState): HighlightState => state.highlight,
);

export default selectors;
